import React, {useState} from "react";
// import chlogo from '../../assets/images/svulogo.webp';
import svmuicon from '../../assets/images/kairos-logo.png';
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import { faClipboardUser, faSquarePollHorizontal, faHospitalUser, faChartSimple, faUsers, faStore,
  faUserTie, faUserGraduate, faGraduationCap, faFileWord,
  faLandmark, faImages, faCalendarWeek, faCircleQuestion, faToolbox, faBullhorn
 } from "@fortawesome/free-solid-svg-icons";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from 'react-redux';

const Sidebar = () => {
  const [selectedindex, setselectedindex] = useState(0);
  const userdata = useSelector((store) => store.userReducer.userdata)
    var navdata = [
        // {name: 'Dashboard', icon: faChartSimple, activeicon: faChartSimple, route: 'admin/dashboard', access: ['superadmin', 'admin']},
        {name: 'Announcement', icon: faBullhorn, activeicon: faBullhorn, route: 'admin/announcement', access: ['superadmin', 'admin']},
        {name: 'Products Range', icon: faToolbox, activeicon: faToolbox, route: 'admin/offered-products', access: ['superadmin', 'admin']},
        {name: 'Enquiries', icon: faCircleQuestion, activeicon: faCircleQuestion, route: 'admin/enquiries', access: ['superadmin', 'admin']},
    ];
    const location = useLocation();
    console.log('location.pathname >>>', location.pathname);
    return (
        <div className="sidebarmaindiv">
            {/* <img src={mainlogo} className="sidebarlogo" /> */}
            <img src={svmuicon} className="sidebarlogo" />
            <div className="sidebarnavmaindiv">
                {navdata?.map((item, index) => {
                  if(item?.access?.includes(userdata?.type)) {
                    var mainclass = "sidebarnavrow";
                    var iconname = item?.icon;
                    if(location.pathname == "/"+item.route) {
                        mainclass = "sidebarnavrow active";
                        iconname = item?.activeicon;
                    }
                    return (
                      <Link
                        to={"/" + item.route}
                        className={mainclass}
                        key={index}
                        onClick={() => {
                          setselectedindex(index);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item?.icon}
                        //   fontSize={19}
                          className="sidebarnavicon"
                          style={{
                            marginLeft: 15,
                            cursor: "pointer",
                          }}
                        />
                        <p className="shoppingtext">{item.name}</p>
                      </Link>
                    );
                  }
                   
                })}
                
            </div>
        </div>
    )
}

export default Sidebar